/* eslint-disable camelcase */
import Vue from 'vue'
import * as types from './mutation-types'
import * as cache from '@/assets/js/cache'
import { inArray } from '@/assets/js/util'
import deepCopy from 'json-deep-copy'

export const addMsg = function ({commit, state}, msg) {
  const uid = msg.uid
  let msgList = deepCopy(state.msgList)
  if (msgList[uid] === undefined) {
    msgList[uid] = []
  }
  msgList[uid].push(msg)
  cache.addMsg(msg)
  cache.setUnReadMsg(msgList)
  commit(types.SET_MSG_LIST, msgList)
  commit(types.SET_UNREAD_MSG, msgList)
}

export const addArticle = function ({commit, state}, id) {
  let articleList = deepCopy(state.readArticleList)
  if (!inArray(id, articleList)) {
    articleList.push(id)
    commit(types.SET_READ_ARTICLE, articleList)
  }
}

export const deleteChatContent = function ({commit, state}, uid) {
  let msgList = state.msgList
  delete msgList[uid]
  msgList = deepCopy(msgList)
  cache.setUnReadMsg(msgList)
  commit(types.SET_MSG_LIST, msgList)
}

export const setNotify = function ({commit, state}, count) {
  commit(types.SET_NOTIFY_COUNT, count)
}

export const addNotify = function ({commit, state}, uid) {
  let notifyCount = state.notifyCount
  let notify = cache.loadNotify()
  if (notify[uid]) {
    notify[uid] += 1
  } else {
    notify[uid] = 1
  }
  notifyCount += 1
  cache.setNotify(deepCopy(notify))
  commit(types.SET_NOTIFY_COUNT, notifyCount)
}

export const deleteNotify = function ({commit, state}, o) {
  const count = o.count
  const uid = o.uid
  let notify = deepCopy(cache.loadNotify())
  let notifyCount = state.notifyCount
  notifyCount -= count
  if (notifyCount < 0) {
    notifyCount = 0
  }
  notify[uid] = notifyCount
  cache.setNotify(notify)
  commit(types.SET_NOTIFY_COUNT, notifyCount)
}

export const setToken = function ({commit, state}, token) {
  cache.setToken(token)
  commit(types.SET_TOKEN, token)
}

export const SOCKET_login = function (a, b) {
  console.log('已经登陆', b)
}

export const SOCKET_disconnect = function () {
  console.log('已经断开了')
}

export const SOKCET_chatMsg = function () {
  console.log('发送了聊天信息')
}

export const SOCKET_message = function ({commit, dispatch, state}, res) {
  const data = res.data
  const user = state.user
  const chats = data.chat || []
  const likes = data.notification_like || []
  const comments = data.notification_comment || []
  const wallets = data.notification_wallet || []
  const follows = data.notification_follow || []
  for (let item of chats) {
    const msg = {
      'uid': item.sender.id,
      'ownerId': user.id,
      'from': item.sender.id,
      'nickname': item.sender.nickname,
      'tnickname': item.sender.nickname,
      'avatar': item.sender.avatar,
      'tavatar': item.sender.avatar,
      'content': item.content,
      'createdDate': item.createdDate / 1000
    }
    dispatch('addMsg', msg)
    dispatch('addNotify', user.id)
  }

  for (let item of likes) {
    let likeMsg = deepCopy(state.likeMsg)
    if (!likeMsg[user.id]) {
      likeMsg[user.id] = []
    }
    likeMsg[user.id].push(item)
    cache.setLikeMsg(likeMsg)
    commit('SET_UNREAD_LIKE_MSG', likeMsg)
  }

  for (let item of comments) {
    let commentMsg = deepCopy(state.commentMsg)
    if (!commentMsg[user.id]) {
      commentMsg[user.id] = []
    }
    commentMsg[user.id].push(item)
    cache.setCommentMsg(commentMsg)
    commit('SET_UNREAD_COMMENT_MSG', commentMsg)
  }

  for (let item of wallets) {
    let walletMsg = deepCopy(state.walletMsg)
    if (!walletMsg[user.id]) {
      walletMsg[user.id] = []
    }
    walletMsg[user.id].push(item)
    cache.setWalletMsg(walletMsg)
    commit('SET_UNREAD_WALLET_MSG', walletMsg)
  }

  for (let item of follows) {
    let followMsg = deepCopy(state.followMsg)
    if (!followMsg[user.id]) {
      followMsg[user.id] = []
    }
    followMsg[user.id].push(item)
    cache.setFollowMsg(followMsg)
    commit('SET_UNREAD_FOLLOW_MSG', followMsg)
  }
}

export const play = function (state ,  url) { 
  if(url) {
      Vue.set(state.state,'radioUrl',url)
      state.playingUrl = url  
  }
  Vue.set(state.state,'radioState','playing')
}

export const pause = function (state) {
  Vue.set(state.state,'radioState','paused')
}

export const changeState = function (state , status) {
  Vue.set(state.state,'radioState',status)
}



// WEBPACK FOOTER //
// ./src/store/actions.js